<template>
  <div
    class="integrations-card"
    :class="[{'integrations-card--disabled': card.status === 'disabled'}, `crm_${card.name}`]"
    :style="{maxWidth: maxWidth}"
  >
    <div class="integrations-card__header">
      <img :src="imageUrl" :alt="displayName" width="48" />
      <snappy-badge :background="isActive ? 'green' : 'grey'">{{ isActive ? 'Connected' : card.status }}</snappy-badge>
    </div>

    <div class="integrations-card__body">
      <h4 class="integrations-card__title">{{ displayName }}</h4>
      <p v-if="!isActive" class="integrations-card__text">
        {{ card.description }}
      </p>
      <template v-else>
        <template v-if="connected">
          <h5 class="integrations-card__top">Account connected on</h5>
          <p class="integrations-card__bottom">{{ connected }}</p>
        </template>
        <template v-if="lastSync">
          <h5 class="integrations-card__top">Last Sync</h5>
          <p class="integrations-card__bottom">{{ lastSync }}</p>
        </template>
      </template>
    </div>

    <div class="integrations-card__footer">
      <slot>
        <a
          class="btn btn-lg btn-outline-primary mr-2 integrations-card__details"
          href="https://intercom.help/snappy-kraken/en/"
          target="_blank"
        >
          <i class="fas fa-external-link-alt" style="font-size: 24px"></i>
          Details
        </a>
        <a v-if="isActive" href="/integrations/catalogue/disconnect" class="btn btn-lg btn-primary">Disconnect</a>
        <button @click="connect" class="btn btn-lg btn-primary" :class="{disabled: connectionDisabled}">Connect</button>
      </slot>
    </div>
  </div>
</template>

<script>
import dateFormatter from '../../../mixins/dateFormatter';
import SnappyBadge from '../../SnappyBadge.vue';
import {getConnectLink} from '../getConnectLink';

export default {
  name: 'integrations-card',
  components: {
    SnappyBadge,
  },
  mixins: [dateFormatter],
  data() {
    return {
      connectLink: null,
    };
  },
  props: {
    available: {
      type: Object,
      required: true,
    },
    card: {
      type: Object,
      required: true,
    },
    connectedCrm: {
      type: [Object, Array],
      required: true,
    },
    timezone: {
      type: String,
    },
    maxWidth: {
      type: String,
    },
  },
  computed: {
    lastSync() {
      if (!this.connectedCrm.last_sync_at) return;
      return `${this.dateLarge(new Date(this.connectedCrm.last_sync_at), this.timezone)} by me`;
    },
    connected() {
      if (!this.connectedCrm.created_at) return;
      return this.dateLarge(new Date(this.connectedCrm.created_at));
    },
    isActive() {
      return this.connectedCrm && this.connectedCrm.crm_name === this.card.name;
    },
    connectionDisabled() {
      return this.card.status === 'disabled' || (Object.keys(this.connectedCrm).length && !this.isActive);
    },
    displayName() {
      return this.card.commercialName;
    },
    imageUrl() {
      return `/wp-content/themes/snappy-theme/assets/images/crms/${this.card.name}.svg`;
    }
  },
  methods: {
    connect() {
      getConnectLink(this.card.name);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../sass/web/_variables.scss';

.integrations-card {
  background: $white-color;
  border: 1px solid $platinum-color;
  border-radius: 4px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 16px;
  width: -webkit-fill-available;
  min-width: 290px;
  &--disabled {
    pointer-events: none;
    filter: grayscale(1) brightness(0.7);
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
  }

  &__body {
    margin: 20px 0;
  }
  &__footer {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto;
    gap: 16px;
  }
  &__details {
    display: flex;
    justify-content: space-around;
  }

  &__title {
    color: $mine-shaft-color;
    font-weight: bold;
    margin-bottom: 8px;
    font-size: 20px;
    line-height: 32px;
  }
  &__text {
    line-height: 24px;
    color: $dove-grey-color;
    margin: 0;
  }
  &__top {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 0;
  }
  &__bottom {
    margin-bottom: 8px;
    color: $dove-grey-color;
  }
}
</style>
